export const dixaWidgetScriptUrl =
  'https://widget.dixa.io/assets/scripts/javascript/loader.js';
export const dixaWidgetId = '9eb1caef-56ba-43e9-9e53-bcd0d58b2550';
export const dixaWidgetAccessKey = '_dixa';

export function dixaWidgetSetUser(profile: {
  email: string;
  name: string;
}): void {
  const { name, email } = profile;
  if (name && email) {
    window?._dixa?.('api.setUser', name, email);
  }
}
export function dixaWidgetPurgeUser(): void {
  window?._dixa?.('api.purgeUser');
}

export function dixaWidgetLoader(): void {
  const tagName = 'script';
  (function (
    window: Window,
    document: Document,
    url: string,
    widgetAccessKey: string,
    widgetId: string,
    newScript: HTMLScriptElement,
    firstScript: HTMLScriptElement,
  ) {
    window[widgetAccessKey] =
      window[widgetAccessKey] ||
      function () {
        (window[widgetAccessKey].q = window[widgetAccessKey].q || []).push(
          // eslint-disable-next-line prefer-rest-params
          arguments,
        );
        // eslint-disable-next-line prefer-rest-params
        window[widgetAccessKey]?.handler?.(arguments);
      };
    window[widgetAccessKey].l = Date.now();
    window[widgetAccessKey].wid = widgetId;
    newScript.async = true;
    newScript.setAttribute('charset', 'utf-8');
    newScript.src = url;
    newScript.onload = injectStyles;
    firstScript.parentNode?.insertBefore(newScript, firstScript);
  })(
    window,
    document,
    dixaWidgetScriptUrl,
    dixaWidgetAccessKey,
    dixaWidgetId,
    document.createElement(tagName),
    document.getElementsByTagName(tagName)[0],
  );
}

function injectStyles(): void {
  const widgetFrame = window.frames['dixa-widget-wrapper'];

  if (!widgetFrame) {
    // there is no way to know when iframe is added to the window
    // and it's not possible to use frame.onload
    setTimeout(injectStyles, 50);
    return;
  }

  const style = document.createElement('style');
  // Hide the button inject by the script. We show a custom button instead.
  style.innerHTML = `#minimized-button { display: none; }`;
  widgetFrame.contentDocument?.querySelector('head')?.appendChild(style);
}
